module.exports = __webpack_public_path__ + "static/media/rocketRun-large.9d7de85f.png";